<template>
   <transition name="modal-fade">
   <div class="modal-backdrop" v-on:click="detect_target">
      <div class="modal-container services_tools">
         <header class="modal-header">
            <button type="button" class="eui-btn--blue" v-on:click="close_modal">close</button>
         </header>
         <section class="modal-body">
            <div class="content" v-if="services_tools && Object.keys(services_tools).length > 0">
               <div class="modal-header-wrapper">
                  <div :class="['icon icon-' + services_tools['info']['capability'].toLowerCase()]">{{services_tools['info']['capability']}}</div>
                  <div class="label-wrapper">
                     <div class="title-label">
                        <a :href="basePath + 'dataset/' + services_tools['info']['dataset']['umm']['ShortName']" target="_blank">{{services_tools['info']['dataset']['umm']['EntryTitle']}}</a>
                     </div>
                     <div style="padding-top:10px">                     
                     <div><strong>Short Name:</strong> {{services_tools['info']['dataset']['umm']['ShortName']}}</div>
                     <div style="padding-top:3px"><strong>Collection Concept ID:</strong> {{services_tools['info']['dataset']['meta']['concept-id']}}</div>
                     </div>
                  </div>
               </div>
               <div v-if="services_tools['tools_services_list']['tools'].length > 0">
                  <h3 class="dataset section-header">Tools</h3>
                  <div v-for="(tool, index) in services_tools['tools_services_list']['tools']" :key="index" class="tool-service-info">
                     <div class="info-wrapper" :set="umm_t=get_ummt_info(tool)">
                        <div class="info-header">
                           <div class="label" v-html="get_tool_title(umm_t, services_tools['info']['dataset']['meta']['concept-id'])"></div>
                           <div class="info-url" v-if="umm_t['information-url'] != undefined">
                              <span v-if="validate_url(umm_t['information-url']) == true">
                                 <a :href="collection_token_replace(umm_t['information-url'],services_tools['info']['dataset']['meta']['concept-id'], services_tools['info']['dataset']['umm']['ShortName'], services_tools['info']['dataset']['umm'])" target="_blank"><i class="fa fa-info-circle" aria-hidden="true"></i> Information</a>
                              </span>
                              <span v-else>
                                 <a class="tool-tip"><i class="fa fa-info-circle" aria-hidden="true"></i><span class="tool-tip-text">{{umm_t['information-url']}}</span> Information</a>
                              </span>
                           </div>
                        </div>
                        <div class="info-content" v-if="umm_t['type'] == 'Downloadable Tool'">                        
                           <code v-html="collection_token_replace(data_access_tool_sample_preprocessing(umm_t['execution-url']), services_tools['info']['dataset']['meta']['concept-id'],services_tools['info']['dataset']['umm']['ShortName'], services_tools['info']['dataset']['umm'])">
                           <!--{{umm_t['execution-url']|collection_token_replace(services_tools['info']['dataset']['meta']['concept-id'],services_tools['info']['dataset']['umm']['ShortName'])}}-->
                           </code>
                        </div>
                     </div>
                  </div>
               </div>
               <div v-if="services_tools['tools_services_list']['services'].length > 0">
                  <h3 class="dataset section-header">Services</h3>
                  <div v-for="(service, index) in services_tools['tools_services_list']['services']" :key="index" class="tool-service-info">
                     <div class="info-header">
                        <div class="label">{{service['name']}}</div>
                        <div class="info-url" v-if="service['information-url'] != undefined">
                           <span v-if="validate_url(service['information-url']) == true">
                              <a :href="service['information-url']" target="_blank"><i class="fa fa-info-circle" aria-hidden="true"></i> Information</a>
                           </span>
                           <span v-else>
                              <a class="tool-tip"><i class="fa fa-info-circle" aria-hidden="true"></i><span class="tool-tip-text">{{service['information-url']}}</span> Information</a>
                           </span>
                        </div>
                     </div>
                     <div class="info-content">
                        <code v-html="collection_token_replace(service['execution-url'], services_tools['info']['dataset']['meta']['concept-id'],services_tools['info']['dataset']['umm']['ShortName'], services_tools['info']['dataset']['umm'])">
                        <!--{{service['execution-url']|collection_token_replace(services_tools['info']['dataset']['meta']['concept-id'],services_tools['info']['dataset']['umm']['ShortName'])}}-->
                        </code>
                     </div>
                  </div>
               </div>
               <div v-if="services_tools['info']['dataset']['umm']['DirectDistributionInformation'] != undefined">
               <div class="access-wrapper" v-if="services_tools['info']['capability'].toLowerCase() == 'download'">
                  <h3 class="dataset section-header">Direct S3-Access</h3>
                  <div class="td_ul">Available for access in-region with AWS Cloud</div>
                  <div v-if="services_tools['info']['dataset']['umm']['DirectDistributionInformation']['Region'] != undefined">
                  <div class="section-wrapper">
                     <div class="td_li"><span class="box__title">Region:</span></div>
                     <div class="td_li_li">{{services_tools['info']['dataset']['umm']["DirectDistributionInformation"]["Region"]}}</div>
                  </div>
                  </div>
                  <div class="section-wrapper">
                     <div class="box__title td_li">Bucket/Object Prefix <a class="tool-tip"><i aria-hidden="true" class="fa fa-info-circle"></i><span class="tool-tip-text"><strong>Protected buckets</strong> contain the data files for a given collection. Protected simply means users must log in to Earthdata Login before gaining access to contents within that S3 Bucket. Please use the S3Credential endpoint to gain an Earthdata login token for use in S3 Access.<br/><br/><strong>Public buckets</strong>, in contrast, house metadata such as checksums, imagery, and metadata files and the like. A user can access public buckets and these types of files without logging in to Earthdata Login.<br/><br/><strong>Most of the time, you’ll want to access the protected bucket</strong></span> Information</a></div>
                     <div v-for="(bucket, bucketIndex) in services_tools['info']['dataset']['umm']['DirectDistributionInformation']['S3BucketAndObjectPrefixNames']" :key="bucketIndex">
                        <div class="td_li_li">{{bucket}}</div>
                     </div>
                  </div>
                  <div class="section-wrapper">
                     <div class="box__title td_li">AWS S3 Credentials</div>
                     <div class="td_li_li">
                     <span class="aws_credential"><a :href="services_tools['info']['dataset']['umm']['DirectDistributionInformation']['S3CredentialsAPIEndpoint']" target="_blank">Get AWS S3 Credentials</a></span><span>&nbsp;|&nbsp;</span>
                     <span class="aws_doc"><a :href="services_tools['info']['dataset']['umm']['DirectDistributionInformation']['S3CredentialsAPIDocumentationURL']" target="_blank">Documentation</a></span>
                     </div>
                  </div>
               </div>
               </div>
            </div>
         </section>
      </div>
   </div>
   </transition>
</template>

<script>
import {mapState} from "vuex";
import table_row_alternate_class from './mixins/table_row_alternate_class';
import datasets_processing from './mixins/datasets_processing';
//import collection_token_replace from './filters/collection_id_placeholder';

export default {
   name: 'service_tools_modal',
   // filters: {
   //    collection_token_replace
   // },
   mixins: [table_row_alternate_class,datasets_processing],
   computed: {
      ...mapState([
         'services_tools',
         'basePath',
         'umm_t_items'
      ])
   },
   methods: {
      get_ummt_info: function(tool) {
         tool['type'] = '';
         this.umm_t_items.forEach(item => {
            if(item['meta']['concept-id'] == tool['concept-id']) tool['type'] = item['umm']['Type'];
         });
         return tool;
      },
      get_tool_title: function(tool, token='') {
         let title_content = '';
         if(tool['type'] == 'Downloadable Tool') {
            title_content = tool['name'];
         } else {
            let exec_url = tool['execution-url'];
            if(token) exec_url = this.collection_token_replace(exec_url, token);
            title_content = '<a href="'+ exec_url  + '" target="_blank">' + tool['name'] + '</a>';
         }
         return title_content;
      },
      collection_token_replace: function(text, concept_id, short_name=undefined, umm_data=undefined) {
         if(concept_id != undefined) {
            text = text.replaceAll('COLLECTION_ID_TOKEN',concept_id);
         }
         if(short_name != undefined) {
            text = text.replaceAll('COLLECTION_SHORTNAME_TOKEN',short_name);
         }
         
         const lat_regex = /lat\(.*?[)]/i;
         let matches = text.match(lat_regex);
         if(matches != null && matches[0].substring(0,3) == 'lat') {
            let replace_text = matches[0].replaceAll('lat(', 'lat(<span style="color:red">').replaceAll(')','</span>)')
            text = text.replaceAll(matches[0], replace_text);
         }
         const lon_regex = /lon\(.*?[)]/i;
         matches = text.match(lon_regex);
         if(matches != null && matches[0].substring(0,3) == 'lon') {
            let replace_text = matches[0].replaceAll('lon(', 'lon(<span style="color:red">').replaceAll(')','</span>)')
            //text = text.replaceAll(matches[0], '<span style="color:red">' + matches[0] + '</span>');
            text = text.replaceAll(matches[0], replace_text);
         }
         const time_regex = /time\(.*?[)]/i;
         matches = text.match(time_regex);
         if(matches != null && matches[0].substring(0,4) == 'time') {
            let replace_text = matches[0].replaceAll('time(', 'time(<span style="color:red">').replaceAll(')','</span>)')
            //text = text.replaceAll(matches[0], '<span style="color:red">' + matches[0] + '</span>');
            text = text.replaceAll(matches[0], replace_text);
         }


         let start_time = undefined;         
         if(umm_data != undefined && umm_data['TemporalExtents'] != undefined) {
            if(umm_data['TemporalExtents'][0]['RangeDateTimes'] != undefined) {
               start_time = umm_data['TemporalExtents'][0]['RangeDateTimes'][0]['BeginningDateTime'];            
            } else if(umm_data['TemporalExtents'][0]['SingleDateTimes'] != undefined) {
               start_time = umm_data['TemporalExtents'][0]['SingleDateTimes'][0];
            }
            if(start_time) {
               try {
                  start_time = start_time.split(".")[0] + "Z";
               } catch (error) {
                  console.log(error);                  
               }               
               text = text.replaceAll('COLLECTION_STARTDATE_TOKEN', start_time);
            }
         }
         
         //return text.replace('COLLECTION_ID_TOKEN',token);
         return text;
      },      
      close_modal: function() {
         this.$emit('close_modal','tools_services');
      },
      detect_target: function(event) {
         if(event.srcElement.getAttribute('class') == 'modal-backdrop') this.close_modal();
      },
      validate_url: function(string) {
         let is_valid = true;
         try {
            const url = new URL(string);
         } catch (_) {
            is_valid = false;
         }
         return is_valid;
      }
   }
}
</script>

<style>
   .modal-backdrop {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
   }
   .modal-container {
      background: #FFFFFF;
      box-shadow: 2px 2px 20px 1px;
      overflow-x: auto;
      display: flex;
      flex-direction: column;
      width: 60%;
      height: 50%;
   }
   .modal-fade-enter,
   .modal-fade-leave-active {
      opacity: 0;
   }

   .modal-fade-enter-active,
   .modal-fade-leave-active {
      transition: opacity .5s ease
   }
</style>